'use client';

import { useShowComposerTreatment } from '~/context/composer/ComposerContext';
import ComposerUiMfe from './ComposerUiMfe';

export default function ComposerUiMfeGate() {
  const showComposerTreatment = useShowComposerTreatment();

  if (!showComposerTreatment) return null;

  return <ComposerUiMfe />;
}
